function hasNonEmptyText(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

function hasStructuredSuggestions(analysis) {
  return Array.isArray(analysis?.suggestions) &&
    analysis.suggestions.some((suggestion) => {
      if (typeof suggestion === 'string') {
        return hasNonEmptyText(suggestion);
      }

      return hasNonEmptyText(suggestion?.title) ||
        hasNonEmptyText(suggestion?.description) ||
        hasNonEmptyText(suggestion?.details) ||
        hasNonEmptyText(suggestion?.summary);
    });
}

export function hasPersonalizedTeaserOptimizationSource({ userIntent, analysis }) {
  return hasNonEmptyText(userIntent?.expectations) || hasStructuredSuggestions(analysis);
}

export function canRequestPersonalizedTeaser({
  analysis,
  imageUrl,
  hasPremiumAccess,
}) {
  return Boolean(analysis) &&
    Boolean(imageUrl) &&
    Boolean(hasPremiumAccess) &&
    hasStructuredSuggestions(analysis);
}
